module.exports = {"610629001":"凤栖街道","610629101":"旧县镇","610629102":"交口河镇","610629103":"老庙镇","610629104":"土基镇","610629105":"石头镇","610629106":"槐柏镇","610629107":"永乡镇","610629200":"菩堤乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610629.json
// module id = 2843
// module chunks = 0